import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';

import {
  Tabs,
  Tab,
  withStyles
} from '@material-ui/core';

const StyledTabs = withStyles((theme) => ({
  root: {
    margin: theme.spacing(0, -2)
  },
  indicator: {
    height: '5px'
  },
}))((props) => <Tabs {...props} />);

const StyledTab = withStyles((theme) => ({
  root: {
    fontFamily: theme.brandFont,
    fontSize: '20px',
    fontWeight: 700,
    letterSpacing: '1.4px',
    minWidth: 0,
    textTransform: 'uppercase',
    padding: 0,
    margin: theme.spacing(0,2)
  },
}))((props) => <Tab disableRipple {...props} />);

const LinkTab = (props) => {
  return (
    <StyledTab
      disableRipple
      component={NavLink}
      {...props}
    />
  );
}

const DraftTabs = props => {
  const location = useLocation();

  return (
    <StyledTabs
      value={location.pathname}
      indicatorColor="primary"
    >
      {props.tabs.map(tab =>
        <LinkTab key={tab.id} label={tab.label} value={tab.url} to={tab.url} />
      )}

    </StyledTabs>
  );
};

DraftTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
    url: PropTypes.string
  }))
};

export default DraftTabs;
